// import {QUELog} from 'qunar-react-native';

export const PopViewType = {
    popViewTypeBindAlert: 'popViewTypeBindAlert',
    popViewTypeHasShareAlert: 'popViewTypeHasShareAlert',//需要特殊处理
}

export default class PopViewManager{
    public queue:any;
    public isShowing = false;

    constructor(){
        this.queue = [];
        this.isShowing = false;
    }

    public addPopView(popViewType:string){
        if (popViewType && popViewType.length > 0){
            //防止网络请求回来多次，导致多次添加弹框
            if(this.queue.length > 0){
                this.queue[this.queue.length - 1] == popViewType
                return; 
            }
            this.queue.push(popViewType)
        }
    }

    public removeCurrentPopView(){
        this.isShowing = false;
        if(this.queue.length > 0){
            // console.log('移除的'+this.queue[0])
            this.queue.shift();
            // console.log(this.queue)
        }
    }

    public checkMemoryPopView() {
        if(this.queue.length <= 0) return null
        this.isShowing = true;
        return this.queue[0]
    }

    //当前是否有弹框在显示
    public isShowingPopView(){
        return this.isShowing;
    }

    //清空内存中所有 popView(如退出登录)
    public clearAllMemoryPopView () {
        this.queue = []
        this.isShowing = false;
    }
}